// assets
import { IconCreditCard } from '@tabler/icons-react';

// ==============================|| USER MENU ITEMS ||============================== //

const user_nav = [
    {
        id: 'electronic-approval',
        title: '전자결재',
        type: 'group',
        icon: IconCreditCard,
        url: '/e-system',
        children: [
            {
                id: 'vacation',
                title: '휴가',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'vacation-form',
                        title: '휴가신청서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'vacation'
                    },
                    // {
                    //     id: 'annual-leave-status',
                    //     title: '연차사용내역 조회',
                    //     type: 'item',
                    //     url: '/e-system/leave'
                    // },
                    {
                        id: 'vacation-status',
                        title: '휴가신청 현황',
                        type: 'item',
                        url: '/e-system/vacation'
                    },
                    // {
                    //     id: 'vacation-status-3',
                    //     title: '조퇴신청현황',
                    //     type: 'item',
                    //     url: '/e-system/half-leave'
                    // }
                ]
            },
            {
                id: 'attendance', // TODO: 적절한 이름으로 교체
                title: '근태',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'attendance-form',
                        title: '근태신청서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'attendance'
                    },
                    {
                        id: 'attendance-status',
                        title: '근태신청 현황',
                        type: 'item',
                        url: '/e-system/attendance'
                    }
                ]
            },
            {
                id: 'business-trip',
                title: '출장',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'business-trip-form',
                        title: '출장신청서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'trip'
                    },
                    {
                        id: 'business-trip-status',
                        title: '출장신청 현황',
                        type: 'item',
                        url: '/e-system/trip'
                    }
                ]
            },
            {
                id: 'education',
                title: '교육',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'education-form',
                        title: '교육신청서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'edu'
                    },
                    {
                        id: 'education-status',
                        title: '교육신청 현황',
                        type: 'item',
                        url: '/e-system/edu'
                    }
                ]
            },
            {
                id: 'overtime',
                title: '연장근무',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'overtime-form',
                        title: '연장근무신청서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'over'
                    },
                    {
                        id: 'overtime-status',
                        title: '연장근무신청 현황',
                        type: 'item',
                        url: '/e-system/over'
                    }
                ]
            },
            {
                id: 'apology', // TODO: 적절한 이름으로 교체
                title: '시말서',
                type: 'collapse',
                url: '/e-system',
                children: [
                    {
                        id: 'apology-form',
                        title: '시말서 작성',
                        type: 'item',
                        url: '/e-system/form',
                        formType: 'apology'
                    },
                    {
                        id: 'apology-status',
                        title: '시말서 현황',
                        type: 'item',
                        url: '/e-system/apology'
                    }
                ]
            }
            // {
            //     id: 'absence',
            //     title: '결근',
            //     type: 'collapse',
            //     url: '/e-system',
            //     children: [
            //         {
            //             id: 'absence-form',
            //             title: '결근사유서 작성',
            //             type: 'item',
            //             url: '/e-system/form?type=absence'
            //         },
            //         {
            //             id: 'absence-status',
            //             title: '결근 현황',
            //             type: 'item',
            //             url: '/e-system/absence'
            //         }
            //     ]
            // }
        ]
    }
];

export default user_nav;